"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var FormUtility_1 = __importDefault(require("../helpers/FormUtility"));
var Form = /** @class */ (function () {
    function Form() {
        var _this = this;
        var formElements = document.querySelectorAll("[".concat(constants_1.DATA_FORM, "]"));
        if (!formElements || !((formElements === null || formElements === void 0 ? void 0 : formElements.length) > 0)) {
            return;
        }
        formElements === null || formElements === void 0 ? void 0 : formElements.forEach(function (formElement) {
            var type = formElement === null || formElement === void 0 ? void 0 : formElement.dataset.form;
            var submit = formElement === null || formElement === void 0 ? void 0 : formElement.querySelector("[".concat(constants_1.DATA_FORM_SUBMIT, "]"));
            var submitText = submit === null || submit === void 0 ? void 0 : submit.querySelector("[".concat(constants_1.DATA_FORM_SUBMIT_TEXT, "]"));
            var submitIcon = submit === null || submit === void 0 ? void 0 : submit.querySelector("[".concat(constants_1.DATA_FORM_SUBMIT_ICON, "]"));
            var formObject = {
                type: type,
                submit: submit,
                submitText: submitText,
                submitIcon: submitIcon,
            };
            _this.setValidationSchema(formElement);
            _this.submitHandler(formElement, formObject);
            if (sessionStorage.getItem('formSent') === type) {
                sessionStorage.removeItem('formSent');
                _this.revalidateInputs(formElement);
            }
        });
    }
    Form.getChecked = function (formElement, string) {
        var checkboxes = this.getAllFields(formElement, string);
        if (checkboxes && checkboxes.length > 0) {
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked) {
                    return true;
                }
            }
            return false;
        }
    };
    Form.getValue = function (formElement, string) {
        var field = this.getField(formElement, string);
        return field ? field.value : '';
    };
    Form.checkValidity = function (validationSchema, validate, fieldWrap) {
        var _this = this;
        var fieldError = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelector("[".concat(constants_1.DATA_FORM_FIELD_ERROR, "]"));
        var fields = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        validationSchema === null || validationSchema === void 0 ? void 0 : validationSchema.validate(validate, { context: { regEx: /\d{5}/ } }).then(function () {
            // remove error styling and hide error message
            if (fieldError && !fieldError.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
                fieldError.classList.add(constantsClasses_1.CLASS_D_NONE);
            }
            if (fieldWrap && fieldWrap.classList.contains(constantsClasses_1.CLASS_INVALID)) {
                fieldWrap.classList.remove(constantsClasses_1.CLASS_INVALID);
            }
            if (fields && fields.length > 0) {
                fields.forEach(function (field) {
                    if (field && field.classList.contains(constantsClasses_1.CLASS_INVALID)) {
                        field.classList.remove(constantsClasses_1.CLASS_INVALID);
                    }
                });
            }
        }).catch(function (error) {
            _this.setError(error, fieldWrap);
        });
    };
    Form.getField = function (formElement, string) {
        return formElement === null || formElement === void 0 ? void 0 : formElement.querySelector("[".concat(constants_1.DATA_FORM_FIELD, "='").concat(string, "']"));
    };
    Form.getAllFields = function (formElement, string) {
        return formElement === null || formElement === void 0 ? void 0 : formElement.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "='").concat(string, "']"));
    };
    Form.getFieldWrap = function (formElement, string) {
        var field = this.getField(formElement, string);
        var fieldWrap = field === null || field === void 0 ? void 0 : field.closest("[".concat(constants_1.DATA_FORM_FIELD_WRAP, "]"));
        return fieldWrap ? fieldWrap : undefined;
    };
    /**
     * Show error and set correct error message
     *
     * @param error
     * @param fieldWrap
     * @private
     */
    Form.setError = function (error, fieldWrap) {
        if (!fieldWrap) {
            return;
        }
        var fieldError = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelector("[".concat(constants_1.DATA_FORM_FIELD_ERROR, "]"));
        var fieldErrorText = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelector("[".concat(constants_1.DATA_FORM_FIELD_ERROR_TEXT, "]"));
        var fields = fieldWrap === null || fieldWrap === void 0 ? void 0 : fieldWrap.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        if (fieldErrorText) {
            fieldErrorText.innerText = error.message;
        }
        if (fieldError && fieldError.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
            fieldError.classList.remove(constantsClasses_1.CLASS_D_NONE);
        }
        if (fieldWrap && !fieldWrap.classList.contains(constantsClasses_1.CLASS_INVALID)) {
            fieldWrap.classList.add(constantsClasses_1.CLASS_INVALID);
        }
        if (fields && fields.length > 0) {
            fields.forEach(function (field) {
                field.classList.add(constantsClasses_1.CLASS_INVALID);
            });
        }
    };
    Form.prototype.revalidateInputs = function (formElement) {
        var validationSchema = this.setValidationSchema(formElement);
        var formInputs = formElement.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        formInputs === null || formInputs === void 0 ? void 0 : formInputs.forEach(function (element) {
            var fieldWrap = element === null || element === void 0 ? void 0 : element.closest("[".concat(constants_1.DATA_FORM_FIELD_WRAP, "]"));
            if (!fieldWrap) {
                return;
            }
            var elType = element.type;
            var identifier = element.dataset.formField;
            var currentValidationSchema = validationSchema.fields[identifier];
            if (['text', 'textarea', 'email', 'tel', 'number'].includes(elType)) {
                element === null || element === void 0 ? void 0 : element.addEventListener('keyup', function () {
                    Form.checkValidity(currentValidationSchema, Form.getValue(formElement, identifier), fieldWrap);
                });
                return;
            }
            if (['checkbox', 'radio'].includes(elType)) {
                element === null || element === void 0 ? void 0 : element.addEventListener('change', function () {
                    Form.checkValidity(currentValidationSchema, Form.getChecked(formElement, identifier), fieldWrap);
                });
                return;
            }
            if (['number', 'date', 'select-one'].includes(elType)) {
                element === null || element === void 0 ? void 0 : element.addEventListener('change', function () {
                    Form.checkValidity(currentValidationSchema, Form.getValue(formElement, identifier), fieldWrap);
                });
                return;
            }
        });
    };
    Form.prototype.setValidationSchema = function (formElement) {
        var formErrorMessages;
        try {
            formErrorMessages = JSON.parse(formElement.dataset.errorMessages);
        }
        catch (e) {
            console.error(e);
            return;
        }
        return FormUtility_1.default.getFormObject(formElement, formErrorMessages);
    };
    Form.prototype.submitHandler = function (formElement, formObject) {
        var _this = this;
        formElement === null || formElement === void 0 ? void 0 : formElement.addEventListener('submit', function (e) { return _this.validateObject(e, formElement, formObject); });
    };
    Form.prototype.disableSubmit = function (formObject) {
        if (formObject.submit) {
            formObject.submit.disabled = true;
        }
        if (formObject.submitText && !formObject.submitText.classList.contains(constantsClasses_1.CLASS_OPACITY_0)) {
            formObject.submitText.classList.add(constantsClasses_1.CLASS_OPACITY_0);
        }
        if (formObject.submitIcon && formObject.submitIcon.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
            formObject.submitIcon.classList.remove(constantsClasses_1.CLASS_D_NONE);
        }
        if (formObject.submitIcon && !formObject.submitIcon.classList.contains(constantsClasses_1.CLASS_ROTATING)) {
            formObject.submitIcon.classList.add(constantsClasses_1.CLASS_ROTATING);
        }
    };
    Form.prototype.enableSubmit = function (formObject) {
        if (formObject.submit) {
            formObject.submit.disabled = false;
        }
        if (formObject.submitText && formObject.submitText.classList.contains(constantsClasses_1.CLASS_OPACITY_0)) {
            formObject.submitText.classList.remove(constantsClasses_1.CLASS_OPACITY_0);
        }
        if (formObject.submitIcon && !formObject.submitIcon.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
            formObject.submitIcon.classList.add(constantsClasses_1.CLASS_D_NONE);
        }
        if (formObject.submitIcon && formObject.submitIcon.classList.contains(constantsClasses_1.CLASS_ROTATING)) {
            formObject.submitIcon.classList.remove(constantsClasses_1.CLASS_ROTATING);
        }
    };
    Form.prototype.validateObject = function (event, formElement, formObject) {
        var _this = this;
        var formValues = FormUtility_1.default.getFormValues(formElement);
        if (!formValues) {
            return;
        }
        var validationSchema = this.setValidationSchema(formElement);
        validationSchema === null || validationSchema === void 0 ? void 0 : validationSchema.validate(formValues, { abortEarly: false }).then(function () {
            sessionStorage.setItem('formSent', formObject.type);
        }).catch(function (error) {
            var _a;
            event.preventDefault();
            _this.disableSubmit(formObject);
            _this.revalidateInputs(formElement);
            (_a = error === null || error === void 0 ? void 0 : error.inner) === null || _a === void 0 ? void 0 : _a.forEach(function (error) {
                if (!error || error && !error.path) {
                    return;
                }
                var fieldWrap = Form.getFieldWrap(formElement, error.path);
                if (!fieldWrap) {
                    return;
                }
                Form.setError(error, fieldWrap);
            });
            var firstError = formElement === null || formElement === void 0 ? void 0 : formElement.querySelector(".".concat(constantsClasses_1.CLASS_INVALID));
            firstError === null || firstError === void 0 ? void 0 : firstError.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
            _this.revalidateInputs(formElement);
            setTimeout(function () {
                _this.enableSubmit(formObject);
            }, 600);
        });
    };
    return Form;
}());
exports.default = Form;
